import { makeStyles } from "@material-ui/core";

export const useTagsTableStyles = makeStyles((theme) => ({
	topTitles: {
		border: "0.0625rem solid black",
		borderBottom: "none",
		backgroundColor: "#f5f7f7",
		color: "#333",
		fontWeight: "normal",
		textAlign: "center",
		padding: "6px 0",
	},

	bottomTitlesRow: {
		"& th": {
			border: "0.0625rem solid black",
			backgroundColor: "#f5f7f7",
			color: "#333",
			fontWeight: "normal",
			textAlign: "center",
			padding: "6px 0",
		},
	},
	checkbox: {
		'& input[type="checkbox"]': {
			zoom: 1.5,
		},
		textAlign: "center",
	},
	rowHover: {
		"&:hover": {
			backgroundColor: "#f2f2f2",
		},
	},

	doubleInput: {
		padding: "0",

		'& input[type="text"] ': {
			width: "100%", // 180px / 16px,
			height: "17px",
			display: "block",
			margin: "0",
			padding: "0",
		},
	},

	inputCol: {
		width: "11.25rem", // 180px / 16px
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	aliasCol: {
		width: "18rem",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	viewSelected: {
		width: "26.125rem",
		padding: "0",
	},
	autoScale: {
		width: "7.5rem", // 120px / 16px
	},
	scale: {
		width: "37.5rem", // 600px / 16px
		padding: "0",
	},
	visible: {
		width: "3.75rem", // 60px / 16px
		fontSize: "12px",
	},
	color: {
		width: "4.375rem", // 70px / 16px
	},
	unit: {
		width: "7.5rem", // 120px / 16px
	},
	numberInput: {
		"&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
			"-webkit-appearance": "none",
			margin: 0,
		},
		"&": {
			"-moz-appearance": "textfield", // to Firefox
		},
	},
	xStats: {
		// ...
	},
	dataType: {
		width: "30px",
		height: "30px",
		color: "white",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		cursor: "pointer",
		border: "1px black solid",
	},
}));
